import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Logo from './Logo';
import { startCheckout } from '../utils/checkout';
import { trackEvent } from '../utils/analytics';
import { ASSET_VERSIONS, getVersionedAsset, SUPPORT_EMAIL } from '../utils/constants';

// Standalone demo-video page, linked from the waitlist confirmation email so
// "send me the demo" lands somewhere durable (not just the homepage modal).
const Demo = () => {
  useEffect(() => {
    trackEvent('demo_page_view', { event_category: 'engagement' });
  }, []);

  const year = new Date().getFullYear();

  return (
    <div className="legal-page">
      <Helmet>
        <title>Watch the demo — SolidlyAI Agents</title>
      </Helmet>

      <header className="legal-header">
        <Link to="/" className="nav-brand" aria-label="SolidlyAI Agents home">
          <span className="nav-logo" aria-hidden="true">
            <Logo size={26} />
          </span>
          <span className="nav-brand-text">
            SolidlyAI <span className="nav-brand-accent">Agents</span>
          </span>
        </Link>
        <Link to="/" className="legal-back">
          ← Back to site
        </Link>
      </header>

      <main className="section-container legal-content demo-content">
        <h1>See your team of AI coworkers in action</h1>
        <p>
          Three minutes, the real app: a workspace of scheduled Claude agents, each with its own
          permissions and skills, picking up work from a live meeting.
        </p>

        <video
          className="demo-page-player"
          src={getVersionedAsset('/videos/demo.mp4', ASSET_VERSIONS.DEMO_VIDEO)}
          poster={getVersionedAsset('/videos/demo-poster.jpg', ASSET_VERSIONS.DEMO_VIDEO)}
          controls
          playsInline
          onPlay={() => trackEvent('demo_page_play', { event_category: 'engagement' })}
        >
          <track
            kind="captions"
            src={getVersionedAsset('/videos/demo.vtt', ASSET_VERSIONS.DEMO_VIDEO)}
            srcLang="en"
            label="English"
            default
          />
        </video>

        <div className="demo-page-cta">
          <button className="btn btn-primary" onClick={() => startCheckout('demo_page')}>
            Buy now — $25 →
          </button>
          <span className="demo-page-cta-note mono">
            One-time purchase · 7-day money-back guarantee
          </span>
        </div>
      </main>

      <footer className="footer-bottom legal-footer">
        <span className="mono">© {year} SolidlyAI Agents</span>
        <span className="mono">
          Questions? <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </span>
      </footer>
    </div>
  );
};

export default Demo;
